import { Responsive } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { trackMenuActionClick, trackMenuClick } from './tracking';
import { setChatbotMenu } from '../../actions/chatbot/actions';
import { openChatbotFiltersModal } from '../../actions/chatbotFiltersModal';
import { ChatbotDesktopMenu, ChatbotMobileMenu } from '../../components/ChatbotMenu';
import { chatbotSelector } from '../../selectors';
import { EChatbotActionType } from '../../services/fetchChatbotActionButtons';
import { getChatbotActionButtons } from '../../thunks/chatbot/getChatbotActionButtons';
import { sendChatbotMessage } from '../../thunks/chatbot/sendChatbotMessage';
import { IChatbotActionButtonSchema } from '../../types/chatbot';

export const ChatbotMenuContainer = () => {
  const { menuActionButtons, messageSending, chatbotMenu, menuText } = useSelector(chatbotSelector);

  const dispatch = useDispatch();

  const toggleMenu = React.useCallback(() => {
    /* istanbul ignore else */
    if (!chatbotMenu.menuIsOpen) {
      trackMenuClick();
    }

    dispatch(setChatbotMenu({ menuIsOpen: !chatbotMenu.menuIsOpen, menuOpenSource: 'menu' }));
  }, [chatbotMenu.menuIsOpen]);

  const handleItemClick = React.useCallback(
    /* istanbul ignore next */
    (menuActionButtons: IChatbotActionButtonSchema) => {
      const { analyticsType, payload, actionType, link, inputText, text } = menuActionButtons;

      dispatch(setChatbotMenu({ menuIsOpen: false, menuOpenSource: chatbotMenu.menuOpenSource }));

      trackMenuActionClick(analyticsType, chatbotMenu.menuOpenSource);

      if (actionType === EChatbotActionType.Payload) {
        dispatch(getChatbotActionButtons(payload, text));

        return;
      }

      /* istanbul ignore next */
      if (actionType === EChatbotActionType.SendMessage) {
        dispatch(sendChatbotMessage(inputText || ''));

        return;
      }

      /* istanbul ignore else */
      if (actionType === EChatbotActionType.Deeplink && link?.includes('chat-bot-profiling')) {
        dispatch(openChatbotFiltersModal());

        return;
      }

      window.open(link, '_blank');
    },
    [dispatch, chatbotMenu.menuOpenSource],
  );

  return (
    <>
      <Responsive desktop>
        <ChatbotDesktopMenu
          isOpen={chatbotMenu.menuIsOpen}
          toggleMenu={toggleMenu}
          actionButtons={menuActionButtons}
          onItemClick={handleItemClick}
          disabled={messageSending}
          menuText={menuText}
        />
      </Responsive>
      <Responsive tablet phone>
        <ChatbotMobileMenu
          isOpen={chatbotMenu.menuIsOpen}
          toggleMenu={toggleMenu}
          actionButtons={menuActionButtons}
          onItemClick={handleItemClick}
          disabled={messageSending}
          menuText={menuText}
        />
      </Responsive>
    </>
  );
};
